import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/footer/line.png'
import _imports_1 from '@/assets/icon/footer/line-hover.png'


const _withScopeId = n => (_pushScopeId("data-v-6ff9a8b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container footer-content" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-2 col-xs-12" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-md-9 offset-md-1 d-flex flex-wrap hidden-xs-only" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "xs-only-jump-data" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "sns-box d-flex" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sns-jump" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "sns-logo no-margin",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "sns-logo hover no-margin",
    src: _imports_1
  })
], -1))
const _hoisted_16 = { class: "line-popover" }
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " QRコードをスキャンするとLINEの友達に追加されます", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "small" }, " QRコードをスキャンするには、LINEアプリのコードリーダーをご利用ください ", -1))
const _hoisted_20 = { class: "row desc" }
const _hoisted_21 = { key: 0 }

import { RouteLocationRaw } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { onMounted, onUnmounted, reactive, ref } from 'vue';
  import { settingStore } from '@/stores';
  import dayjs from 'dayjs';
  import { IS_KO_PRODUCTON } from '@/constants';
  import _ from 'lodash';

  type JumpItem = {
    name: string;
    path: RouteLocationRaw,
    otherPath?: string
  }

  interface Props {
    logoSrc?: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    logoSrc: { default: require('@/assets/logo.png') }
  },
  setup(__props: any) {

const props = __props as { logoSrc: string }

  

  const { t, locale } = useI18n();

  const isJa = locale.value === 'ja';
  const isProduction = process.env.VUE_APP_ENV === 'production';
  const currentYear = dayjs().year();

  const termsOfUse: JumpItem = {
    name: t('termsOfUse'),
    path: { name: 'staticPage', params: { slug: 'terms_of_use' } }
  };
  // const operationPolicy: JumpItem = {
  //   name: t('operationPolicy'),
  //   path: { name: 'staticPage', params: { slug: 'operation_policy' } }
  // };
  const privacyPolicy: JumpItem = {
    name: t('privacyPolicy'),
    path: { name: 'staticPage', params: { slug: 'privacy_policy' } }
  };
  const mediaRoom: JumpItem = {
    name: t('mediaRoom'),
    path: { name: 'mediaRoom' },
    otherPath: (isJa && isProduction) ? 'https://www.terracycle.com/ja-JP/pages/pressrelease-tc-jp' : ''
  };
  // const locationBased: JumpItem = {
  //   name: t('locationBased'),
  //   path: { name: 'staticPage', params: { slug: 'service_terms_and_conditions' } }
  // };
  const contactUs: JumpItem = {
    name: t('contactUs'),
    path: { name: 'contactUs' },
    otherPath: (isJa && isProduction) ? 'https://www.terracycle-jp.com/contact_us' : ''
  };

  const businessInquiry: JumpItem | null = IS_KO_PRODUCTON ? null : {
    name: t('Business inquiry'),
    path: { name: 'business_inquiry' },
  };

  const inquiryToUse: JumpItem | null = IS_KO_PRODUCTON ? null : {
    name: t('Inquiry To Use'),
    path: { name: 'inquiry_to_use' },
  };

  const faq: JumpItem | null = IS_KO_PRODUCTON ? null : {
    name: t('FAQ'),
    path: { name: 'faq.index' },
    otherPath: (isJa && isProduction) ? 'https://help.jp.terracycle.com/hc/ja' : ''
  };

  const filterJaMenus = [businessInquiry, inquiryToUse].filter(Boolean) as JumpItem[];

  const jumpDatas = ([termsOfUse, privacyPolicy, mediaRoom, contactUs, businessInquiry, inquiryToUse, faq].filter(Boolean) as JumpItem[]).filter(item => isJa ? !filterJaMenus.includes(item) : true);

  const snsData = reactive({
    facebook: {
      imageUrl: require('@/assets/icon/footer/facebook.png'),
      hoverUrl: require('@/assets/icon/footer/facebook-hover.png'),
      link: ''
    },
    twitter: {
      imageUrl: require('@/assets/icon/footer/twitter.png'),
      hoverUrl: require('@/assets/icon/footer/twitter-hover.png'),
      link: ''
    },
    youtube: {
      imageUrl: require('@/assets/icon/footer/youtube.png'),
      hoverUrl: require('@/assets/icon/footer/youtube-hover.png'),
      link: ''
    },
    instagram: {
      imageUrl: require('@/assets/icon/footer/Instagram.png'),
      hoverUrl: require('@/assets/icon/footer/Instagram-hover.png'),
      link: ''
    },
    linkedin: {
      imageUrl: require('@/assets/icon/footer/LinkedIn.png'),
      hoverUrl: require('@/assets/icon/footer/LinkedIn-hover.png'),
      link: ''
    }
  });

  onMounted(async () => {
    await settingStore.tryFetchData();
    snsData.facebook.link = settingStore.data.official_facebook_link;
    snsData.twitter.link = settingStore.data.official_twitter_link;
    snsData.youtube.link = settingStore.data.official_youtube_link;
    snsData.instagram.link = settingStore.data.official_instagram_link;
    snsData.linkedin.link = settingStore.data.official_linkedin_link;
  });


  const onPageResize = _.debounce(setFooterHeight, 500);
  onMounted(() => {
    setFooterHeight();
    window.addEventListener('resize', onPageResize);
  });

  onUnmounted(() => {
    document.body.style.setProperty('--tc-footer-height', '0px');
    window.removeEventListener('resize', onPageResize);
  });

  const footerRef = ref<HTMLDivElement>();
  function setFooterHeight() {
    const h = footerRef.value?.offsetHeight;
    document.body.style.setProperty('--tc-footer-height', `${h}px`);
  }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppPopover = _resolveComponent("AppPopover")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "footerRef",
    ref: footerRef,
    class: "footer-wrapper"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: props.logoSrc,
            class: "logo"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(jumpDatas), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "jump-item"
            }, [
              (item.otherPath)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: item.otherPath,
                    class: "router-link",
                    target: "_blank"
                  }, _toDisplayString(item.name), 9, _hoisted_6))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "router-link",
                    to: item.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "router-link",
              to: termsOfUse.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(termsOfUse.name), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "router-link",
              to: privacyPolicy.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(privacyPolicy.name), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "router-link",
              to: contactUs.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(contactUs.name), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(snsData), (item, key) => {
          return (_openBlock(), _createElementBlock("a", {
            key: key,
            href: item.link,
            target: "_blank",
            class: "sns-jump"
          }, [
            _createElementVNode("img", {
              src: item.imageUrl,
              class: "sns-logo"
            }, null, 8, _hoisted_13),
            _createElementVNode("img", {
              src: item.hoverUrl,
              class: "sns-logo hover"
            }, null, 8, _hoisted_14)
          ], 8, _hoisted_12))
        }), 128)),
        (_unref(locale) === 'ja' && _unref(settingStore).data.line_qrcode?.url)
          ? (_openBlock(), _createBlock(_component_AppPopover, {
              key: 0,
              name: "line-popover"
            }, {
              trigger: _withCtx(() => [
                _hoisted_15
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("img", {
                    src: _unref(settingStore).data.line_qrcode?.url
                  }, null, 8, _hoisted_17),
                  _hoisted_18,
                  _hoisted_19
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        (_unref(locale) === 'ja')
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, " Copyright © " + _toDisplayString(_unref(currentYear)) + ". All Rights Reserved ", 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" TerraCycle Korea, SK V1 Tower 13F, 25 Yeonmujang 5ga-gil, Seongdong-gu, Seoul, Republic of Korea | Copyright © " + _toDisplayString(_unref(currentYear)) + ". All Rights Reserved ", 1)
            ], 64))
      ])
    ])
  ], 512))
}
}

})